import React, { useState } from "react";
import getTableColumns from "./getTableColumns";
import { IColumnProps } from "../Column";
import { CellContext, ColumnDefTemplate, RowData, StringOrTemplateHeader } from "@tanstack/react-table";
import getColumnProps from "./getColumnProps";
import { MRT_ColumnDef } from "mantine-react-table";

interface ICellDescriptorProps {
  children: React.ReactNode;
}

interface ICellDescriptor<TData extends Record<string, any> = {}> extends MRT_ColumnDef<TData> {

}

interface ITableColumns<TData extends Record<string, any> = {}> {
  columns: ICellDescriptor<TData>[];
}

function useCellDescriptor<TData extends Record<string, any> = {}>(
  children: ICellDescriptorProps
): ITableColumns<TData> {
  const [cacheData, setCacheData] = useState<ICellDescriptor<TData> | null>();

  const columns = getTableColumns(children) as React.ReactElement[];
  const count = columns.length;

  const tableColumns: ITableColumns<TData> = { columns: [] };

  React.Children.forEach(
    columns,
    (column: React.ReactElement<IColumnProps<TData>>, index) => {
      if (React.isValidElement(column)) {
        //const columnChildren = column.props.children as React.ReactNode[];
        const columnProps = getColumnProps(column);
        const {
          fieldName,

          ...rest
        } = columnProps;

        let col = { ...rest }
        col.accessorKey = col.accessorKey ?? fieldName;

        tableColumns.columns.push(col);
      }
    }
  );

  return tableColumns;
}

export default useCellDescriptor;
